<template>
  <div>
    <b-modal id="terms-of-service-modal" centered no-close-on-backdrop no-close-on-esc hide-header-close>
      <template #modal-header>
        <b-row class="w-100" align-v="center" no-gutters>
          <b-col>
            <h2 class="modal-title">
              <i class="far fa-exclamation-circle mr-1" />
              {{ $t('xTermsOfServiceUpdate') }}
            </h2>
          </b-col>
        </b-row>
      </template>
      <b-row>
        <b-col>
          <p>
            {{ $t('xOur') }}
            <a :href="termsConditionsUrl" target="_blank" rel="noopener noreferrer"> {{ $t('xTermsOfService') }}</a
            >, <a :href="eulaUrl" target="_blank" rel="noopener noreferrer"> {{ $t('xEULA') }}</a
            >,
            {{ $t('xAnd') }}
            <a :href="privacyPolicyUrl" target="_blank" rel="noopener noreferrer"> {{ $t('xPrivacyNotice') }}</a>
            {{ $t('xTermsOfServiceUpdateBody') }}
          </p>
        </b-col>
      </b-row>
      <b-row class="mt-2"> </b-row>
      <b-row class="mt-3">
        <b-col class="d-flex align-items-start">
          <b-form-checkbox
            data-test-hook="checkbox-terms-and-conditions-modal"
            v-model="termsOfServiceAccepted"
            :state="shouldShowCheckBoxError ? false : null"
            :disabled="isLoading"
            class="mr-2 mt-1"
          >
          </b-form-checkbox>
          <div>
            {{ $t('xTermsOfServiceUpdateIAgree') }}
            <div class="text-danger" v-if="!termsOfServiceAccepted && continuePressed">
              <p>{{ $t('xTermsOfServiceUpdateMustAgree') }}</p>
            </div>
          </div>
        </b-col>
      </b-row>
      <template #modal-footer>
        <b-row class="box w-100" no-gutters>
          <b-button
            variant="secondary"
            data-test-hook="logout-button-terms-conditions-modal"
            :disabled="isLoading"
            @click="onLogout()"
          >
            {{ $t('xLogout') }}
          </b-button>
          <b-button
            variant="primary"
            data-test-hook="continue-button-terms-conditions-modal"
            :disabled="isLoading"
            @click="onContinue()"
          >
            {{ $t('xContinue') }}
          </b-button>
        </b-row>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { vueAppApiBaseAddress } from '@/utils/mixins'

export default {
  data() {
    return {
      termsOfServiceAccepted: false,
      continuePressed: false,
      isLoading: false,
      termsConditionsUrl: process.env.VUE_APP_TERMS_CONDITIONS_URL,
      eulaUrl: process.env.VUE_APP_EULA_URL,
      privacyPolicyUrl: process.env.VUE_APP_PRIVACY_POLICY_URL
    }
  },
  computed: {
    shouldShowCheckBoxError() {
      return !this.termsOfServiceAccepted && this.continuePressed
    }
  },
  methods: {
    async onContinue() {
      this.continuePressed = true
      if (!this.termsOfServiceAccepted) {
        return
      }
      this.isLoading = true
      try {
        await this.$store.dispatch('updateTermsAndConditions', true)
        this.$bvModal.hide('terms-of-service-modal')
      } catch (e) {
        this.showErrorToast()
      } finally {
        this.isLoading = false
      }
    },
    showErrorToast() {
      this.$store.dispatch('displayToast', {
        title: this.$t('xSomethingWentWrong'),
        message: this.$t('xPleaseWaitAndTryAgain'),
        variant: 'danger'
      })
    },
    async onLogout() {
      this.isLoading = true
      try {
        await this.$store.dispatch('clearAll')
        window.location.replace(vueAppApiBaseAddress() + `Auth/Auth0/SignOut`)
      } catch (e) {
        this.showErrorToast()
      } finally {
        this.isLoading = false
      }
    }
  },
  watch: {
    termsOfServiceAccepted() {
      this.continuePressed = false
    }
  }
}
</script>

<style scoped>
.box {
  display: flex;
  gap: 12px;
}

.box > * {
  flex: 1 1 0;
}

.custom-control-input.is-invalid ~ .custom-control-label {
  color: inherit;
}
</style>
